import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  SandboxParticipantsRequest extends  DBObject {  private static readonly _PHONE: number = 0 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _phone: string = '' ;
 public constructor ( d3eParams ? : Partial<{phone: string}> ) {
 super();

this.setPhone(d3eParams?.phone ?? '');
 }
  public get d3eType (  ) : string {
 return 'SandboxParticipantsRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get phone (  ) : string {
 return this._phone ; 
 }
  public setPhone ( val : string ) : void {
 let isValChanged :boolean=this._phone !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(SandboxParticipantsRequest._PHONE,this._phone);

this._phone=val;

this.fire('phone',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case SandboxParticipantsRequest._PHONE : {
 return this._phone ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : SandboxParticipantsRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :SandboxParticipantsRequest=( dbObj as SandboxParticipantsRequest );

obj.id=this.id;

obj.setPhone(this._phone);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case SandboxParticipantsRequest._PHONE : {
 this.setPhone(( value as string ));
 break; }
 }
 }
 }